import React from 'react'
import { MenuItemType } from '@utils/types'
import { WContainer, EditableTitle } from '@components/atoms'
import styles from './EventiProgrammaSection.module.sass'
import { CalendarDateCard } from '@components/molecules'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const EventiProgrammaSection = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <WContainer>
        {(!!item.name || !!item.description || (!!item.ctaLabel && !!item.url)) && (
          <div className={styles.main}>
            {(!!item.name || !!item.description) && (
              <div className={styles.content}>
                <EditableTitle
                  title={item.name}
                  variant="h2"
                  className={styles.title}
                  editMode={editMode}
                />
              </div>
            )}
          </div>
        )}
        {editMode ? (
          <>{item.children}</>
        ) : (
          <div className={`${styles.list}`}>
            {item.children?.map((x) => (
              <CalendarDateCard item={x} key={x.pk} className={styles.item} />
            ))}
          </div>
        )}
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default EventiProgrammaSection
